var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 77 77"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 36.895,
  fill: "#8ba7ab",
  rx: 1.604
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  y: 40.104,
  fill: "#000",
  rx: 1.604,
  transform: "rotate(-90 0 40.104)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 20.639,
  y: 72.644,
  fill: "#1e2d30",
  rx: 1.604,
  transform: "rotate(-150 20.639 72.644)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 59.139,
  y: 71.04,
  fill: "#39555a",
  rx: 1.604,
  transform: "rotate(150 59.139 71.04)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 72.644,
  y: 56.361,
  fill: "#47696f",
  rx: 1.604,
  transform: "rotate(120 72.644 56.36)"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 71.04,
  y: 17.861,
  fill: "#6f9298",
  rx: 1.604,
  transform: "rotate(60 71.04 17.86)"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 40.105,
  y: 77,
  fill: "#2c4145",
  rx: 1.604,
  transform: "rotate(180 40.105 77)"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 77,
  y: 36.896,
  fill: "#547d84",
  rx: 1.604,
  transform: "rotate(90 77 36.896)"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 56.361,
  y: 4.356,
  fill: "#8ba7ab",
  rx: 1.604,
  transform: "rotate(30 56.361 4.356)"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 17.861,
  y: 5.96,
  fill: "#c1d0d3",
  rx: 1.604,
  transform: "rotate(-30 17.861 5.96)"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 4.355,
  y: 20.639,
  fill: "#a6bbbf",
  rx: 1.604,
  transform: "rotate(-60 4.355 20.64)"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 3.208,
  height: 19.25,
  x: 5.96,
  y: 59.139,
  fill: "#1e2d30",
  rx: 1.604,
  transform: "rotate(-120 5.96 59.14)"
})));
export default SvgLoading;